import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-[80vh] flex items-center overflow-hidden bg-white py-12 lg:py-0" data-id="element-78">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#000 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-79"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10" data-id="element-80">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-81">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="flex flex-col items-start space-y-8" data-id="element-82">
            <div className="relative inline-block" data-id="element-83">
              <div className="absolute -top-6 -right-6 bg-magenta text-white font-black px-4 py-1 rotate-12 brutal-border brutal-shadow z-20 text-xl" data-id="element-84">
                קולקציית 2026
              </div>
              <h1 className="text-7xl sm:text-8xl lg:text-9xl font-black leading-[0.85] tracking-tighter" data-id="element-85">
                <span className="block text-black" data-id="element-86">ללבוש</span>
                <span className="block text-acid brutal-text-shadow" style={{
                textShadow: '4px 4px 0 #000'
              }} data-id="element-87">
                  את
                </span>
                <span className="block text-electric" style={{
                textShadow: '4px 4px 0 #000'
              }} data-id="element-88">
                  המרד.
                </span>
              </h1>
            </div>

            <p className="text-2xl font-bold max-w-md leading-tight" data-id="element-89">
              לא לעדינים. אופנת רחוב ששוברת את החוקים ובועטת במוסכמות.
            </p>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="brutal-btn bg-black text-white text-3xl px-10 py-5 hover:bg-acid hover:text-black w-full sm:w-auto" data-id="element-90">
              גלה את הקולקציה
            </motion.button>
          </motion.div>

          {/* Image/Graphic Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-91">
            <div className="absolute inset-0 bg-magenta brutal-border translate-x-4 translate-y-4" data-id="element-92"></div>
            <div className="relative bg-acid brutal-border p-2 z-10 hover:-translate-y-2 hover:-translate-x-2 transition-transform duration-300" data-id="element-93">
              <img src="https://images.unsplash.com/photo-1523398002811-999aa8e9f5b9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Streetwear Model" className="w-full h-auto object-cover brutal-border grayscale contrast-150 hover:grayscale-0 transition-all duration-500" data-id="element-94" />
              {/* Sticker */}
              <div className="absolute -bottom-8 -left-8 bg-electric text-white font-black p-6 rounded-full brutal-border brutal-shadow-lg w-32 h-32 flex items-center justify-center -rotate-12 hover:rotate-0 transition-transform cursor-pointer" data-id="element-95">
                <span className="text-center leading-none text-xl" data-id="element-96">
                  SOLD
                  <br data-id="element-97" />
                  OUT
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}